import React from 'react'
import PropTypes from 'prop-types'

function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
      <g fill="none">
        <path
          d="M89.947 90.262c-.017 2.61-2.24 4.722-4.986 4.738H14.987a5.008 5.008 0 0 1-3.517-1.396A4.608 4.608 0 0 1 10 90.262V4.738a4.52 4.52 0 0 1 1.47-3.342A5.008 5.008 0 0 1 14.987 0h42.94a5.233 5.233 0 0 1 3.569 1.396L88.53 27.08a4.63 4.63 0 0 1 1.47 3.39v59.793h-.053Z"
          fill="#EBECF0"
        />
        <path
          d="M90 91v4.5c.007 1.194-.523 2.34-1.47 3.174-.932.846-2.198 1.323-3.52 1.326H14.99c-2.756 0-4.99-2.015-4.99-4.5V91c.017 2.479 2.241 4.484 4.99 4.5h70.02c2.756 0 4.99-2.015 4.99-4.5Z"
          fill="#C1C7D0"
        />
        <path
          d="M0 52h100v24.175C100 78.84 97.767 81 95.013 81H5.04a4.96 4.96 0 0 1-3.517-1.422 4.756 4.756 0 0 1-1.47-3.454V52H0Z"
          fill="#FF1D1D"
        />
        <path d="M10 53V43L0 53h10Zm80 0 .104-10L100 53H90Z" fill="#D30000" />
        <path
          d="M89.997 30.354V31H62.983C60.231 31 58 28.887 58 26.28V0a5.237 5.237 0 0 1 3.567 1.391l27.066 25.585a4.51 4.51 0 0 1 1.364 3.378Z"
          fill="#C1C7D0"
        />
        <path fill="#C1C7D0" opacity={0.2} d="m65 26 25 25-.073-21.19z" />
        <text fill="#FFF">
          <tspan x={33} y={73}>
            PDF
          </tspan>
        </text>
      </g>
    </svg>
  )
}
const PdfIcon = (props) => {
  const { width, height } = props
  return (
    <div style={{ width, height }}>
      <Icon />
    </div>
  )
}

// 默认参数
PdfIcon.defaultProps = {
  width: 12,
  height: 12,
}
// 参数类型
PdfIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
}

export default PdfIcon
